
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[custompage]/[innerPage]",
      function () {
        return require("private-next-pages/[custompage]/[innerPage].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[custompage]/[innerPage]"])
      });
    }
  